export const prescreenQueryKeys = {
  invite: (slug: string) => ['prescreen', 'invite', slug] as const,
  name: (candidateJobId: string) =>
    ['prescreen', 'name', candidateJobId] as const,
  job: (candidateJobId: string) =>
    ['prescreen', 'job', candidateJobId] as const,
};
